export default "<p>\r\n  network-check works!\r\n</p>\r\n"